import { create } from 'zustand';
import type { InboxItem } from '@goodchat/shared/types';

interface InboxStore {
  items: InboxItem[];
  hasMore: boolean;
  counts: { unread: number; acknowledgmentsPending: number; replyLater: number };
  filter: 'all' | 'unread' | 'acknowledgment' | 'reply_later';
  loading: boolean;
  selectedMessageId: string | null;
  setFilter: (filter: 'all' | 'unread' | 'acknowledgment' | 'reply_later') => void;
  setCounts: (counts: { unread: number; acknowledgmentsPending: number; replyLater: number }) => void;
  setItems: (items: InboxItem[], hasMore: boolean) => void;
  appendItems: (items: InboxItem[], hasMore: boolean) => void;
  removeItem: (messageId: string) => void;
  updateItem: (messageId: string, updater: (item: InboxItem) => InboxItem) => void;
  setLoading: (loading: boolean) => void;
  setSelectedMessageId: (messageId: string | null) => void;
}

export const useInboxStore = create<InboxStore>((set) => ({
  items: [],
  hasMore: false,
  counts: { unread: 0, acknowledgmentsPending: 0, replyLater: 0 },
  filter: 'all',
  loading: false,
  selectedMessageId: null,

  setFilter: (filter) => set({ filter }),

  setCounts: (counts) => set({ counts }),

  setItems: (items, hasMore) => set({ items, hasMore }),

  appendItems: (items, hasMore) =>
    set((s) => ({
      items: [...s.items, ...items],
      hasMore,
    })),

  removeItem: (messageId) =>
    set((s) => ({
      items: s.items.filter((i) => i.messageId !== messageId),
    })),

  updateItem: (messageId, updater) =>
    set((s) => ({
      items: s.items.map((i) => (i.messageId === messageId ? updater(i) : i)),
    })),

  setLoading: (loading) => set({ loading }),

  setSelectedMessageId: (messageId) => set({ selectedMessageId: messageId }),
}));
